export const PREVIOUS_MEETINGS = {
  DEFAULT_COLLAPSED_LIST_SIZE: 5,
  DEFAULT_EXPANDED_LIST_SIZE: 10,
  ACTION_TYPES: {
    fetchGames: 'fetchGames',
    toggleCollapsed: 'toggleCollapsed'
  }
}
